import { Grid, useEventCallback } from '@mui/material';
import { memo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import TypeVoidCivilUnionList from 'shell/components/shared/type-void-civil-union-list';
import { CancelCivilUnionVM } from 'mutation/view-models/cancel-civil-union';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';
import { TypeCancelCivilUnion } from 'shell/constants/type-cancel-civil-union';
import PmiDivider from 'shell/components/shared/divider';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import DocumentActForm from 'shell/components/shared/act';

interface CancelCivilUnionFormProps {
  values?: CancelCivilUnionVM;
  onChange: (
    key: keyof CancelCivilUnionVM,
    value: CancelCivilUnionVM[keyof CancelCivilUnionVM]
  ) => void;
  onChangeValues: (values: CancelCivilUnionVM) => void;
  errors?: FormikErrors<CancelCivilUnionVM>;
  touched?: FormikTouched<CancelCivilUnionVM>;
}

const CancelCivilUnionFormComponent = ({
  values,
  onChange,
  onChangeValues,
  errors,
  touched,
}: CancelCivilUnionFormProps): React.ReactElement => {
  const handleTypeVoidCivilUnionListChange = useEventCallback((value: string | undefined) => {
    onChange('reasonCancel', value);
  });

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data evento *"
          value={values?.eventDate || null}
          onChange={(dataValue) => {
            onChange('eventDate', dataValue || null);
          }}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="eventDate"
              fullWidth
              error={touched?.eventDate && Boolean(errors?.eventDate)}
              helperText={errors?.eventDate}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <TypeVoidCivilUnionList
          label="Motivo scioglimento"
          aria-label="Motivo scioglimento"
          required
          error={touched?.reasonCancel && Boolean(errors?.reasonCancel)}
          value={values?.reasonCancel || ''}
          onChange={handleTypeVoidCivilUnionListChange}
          filterList={(items) => {
            return items.filter((item) => item.id !== TypeCancelCivilUnion.DeathCohabitant);
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTitleDivider>Atto di scioglimento</PmiTitleDivider>
      </Grid>
      <Grid item xs={12}>
        <PmiDivider />
      </Grid>
      <DocumentActForm
        values={values}
        requiredDigital={{
          documentDate: false,
        }}
        onChange={(key, value) => {
          onChange(key, value);
        }}
        onChanges={(fields) => {
          onChangeValues(fields);
        }}
        errors={errors}
        touched={touched}
      />
    </Grid>
  );
};

CancelCivilUnionFormComponent.displayName = 'Cancel Civil Union Form component';

const CancelCivilUnionForm = memo(CancelCivilUnionFormComponent);

export default CancelCivilUnionForm;
